import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "js-cookie";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BsClipboard } from "react-icons/bs";
import Swal from "sweetalert2";
import { publicIpv4 } from "public-ip";
import { useNavigate } from 'react-router-dom';
import useLanguage from "../../../../Hooks/useLanguage";
import { useTranslation } from 'react-i18next';
import LoadingSpinner from "../../../../css/Loading";
const baseURL = process.env.REACT_APP_API_URL;
const OrderDetailPanel = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null)
    const [showPassword, setShowPassword] = useState(false);
    const [showApppass, setShowApppass] = useState(false);
    const { orderID } = useParams();
    const [copied, setCopied] = useState("");
    const token = Cookies.get("Token");
    const [isUpdated, setIsUpdated] = useState(false);
    const [isReinstallDisabled, setIsReinstallDisabled] = useState(false);
    const [images, setImages] = useState([]);
    const [ipAddress, setIpAddress] = useState("");
    const { t } = useTranslation();
    useLanguage();
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);

    const navi = useNavigate();
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await fetch(`${baseURL}/api/v1/images`);
                if (response.ok) {
                    const data = await response.json();
                    setImages(data);
                } else {
                    console.error("Không thể tải dữ liệu images.json");
                }
            } catch (error) {
                console.error("Lỗi khi tải images.json:", error);
            }
        };
        fetchImages();
    }, []);

    const fetchData = async () => {
        const token = Cookies.get("Token");
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/v1/cshp-order-details/${orderID}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setData(response.data.order_details);
        } catch (err) {
            setError("Lỗi khi tải dữ liệu từ API.");
        } finally {
            setLoading(false);
        }
    };

    console.log("data", data)
    useEffect(() => {
        fetchData();
    }, [isUpdated]);
    useEffect(() => {
        if (data) {
            const currentStatus = Number(data.status);
            setIsReinstallDisabled(currentStatus === 9);
        }
    }, [data]);
    useEffect(() => {
        fetchData();
    }, []);



    const handleDeleteVM = async () => {
        const result = await Swal.fire({
            html: `
               <div class='row' style="font-size:14px; line-height:1.6;">
                   <div class='col-12' style="margin-bottom:12px;">
                       <span style="font-size:16px;">
                           Bạn có muốn xóa dịch vụ 
                           <strong>[ ${accountInfo?.domain_hosting_name || 'Tên Miền Chưa Cập Nhật'} ]</strong> 
                           không?
                       </span><br>
                       <span style="font-size:14px; line-height:1.6; color:red;">
                         Nếu tiếp tục CSHP của bạn sẽ bị xóa
        
                       </span>
                   </div>
                
                   <div class='col-12' style="margin-bottom:12px;">
                       <b>Nhập chữ <span style="color:red;">CONFIRM</span> để xác nhận thao tác này:</b>
                   </div>
                   <div class='col-12'>
                       <input
                           id="confirmInput"
                           type="text"
                           placeholder="Nhập CONFIRM để xác nhận"
                            autocomplete="off"
                           style="padding: 8px; font-size: 14px; width: 250px; height: 30px; border: 1px solid #000; border-radius: 5px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                   </div>
               </div>
               `,
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            focusConfirm: false,
            showCloseButton: true,
            confirmButtonColor: "#dc3545",
            customClass: {
                popup: 'swal2-popup-centered custom-popup',
                input: 'swal2-input-small'
            },
            width: '600px',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
                document.querySelector('.swal2-confirm').style.visibility = 'hidden';
                document.querySelector('.swal2-cancel').style.visibility = 'hidden';

                const imageDropdown = document.getElementById('imageDropdown');
                const inputField = document.getElementById('confirmInput');
                const inputValue = inputField ? inputField.value : "";
                if (inputValue.toUpperCase() !== "CONFIRM") {
                    Swal.showValidationMessage(`
                           <span style="color: red; font-size: 14px;">
                               ❌ Vui lòng nhập đúng CONFIRM!
                           </span>
                       `);
                    return false;
                }

                Swal.showLoading();

                try {
                    const response = await fetch(`${baseURL}/api/v1/control/cancel`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            order_detail_id: data?.id,
                            type: 1,
                            ip_address: ipAddress,
                        })
                    });

                    if (!response.ok) {
                        throw new Error("Có lỗi xảy ra khi xóa máy ảo.");
                    }

                    Swal.showValidationMessage(`
                           <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                   <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                   <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                               </svg>
                               <span>Thành công! Máy ảo đã được xóa.</span>
                           </div>
                       `);
                    Swal.hideLoading();
                    setTimeout(() => {
                        const cancelButton = document.querySelector('.swal2-cancel');
                        cancelButton.innerText = 'Close';
                        cancelButton.style.visibility = 'visible';
                        cancelButton.style.position = 'absolute';
                        cancelButton.style.left = '50%';
                        cancelButton.style.transform = 'translateX(-50%)';
                    });
                    setTimeout(() => {
                        Swal.close();
                    }, 2000);
                    delayFetchData(2000);
                    delayFetchData(2000);


                } catch (error) {
                    Swal.showValidationMessage(`
                           <span style="color: red; font-size: 14px;">
                               ❌ Lỗi: ${error.message}
                           </span>
                       `);
                    Swal.hideLoading();
                }
            }
        });

        if (!result.isConfirmed) {
            console.log("Hủy thao tác xóa.");
        }
    }

    const delayFetchData = (delay = 2000) => {
        setTimeout(() => fetchData(), delay);
    };

    console.log("data", data)


    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    } if (error) return <p className="text-danger">{error}</p>;

    const accountInfo = {
        ipAddress: data?.ip,
        osStatus: data?.images || "N/A",
        osversion: data?.images_version || "N/A",
        cpu: `${data?.package?.core || "N/A"} vCore`,
        ram: `${data?.package?.memory || "N/A"} GB`,
        ssd: `${data?.package?.storage || "N/A"} GB`,
        port: `${data?.port || "N/A"} `,
        hostname: data?.domain_hosting_name,
        status: data?.status ?? "N/A",
        domain_hosting_name: `${data?.domain_hosting_name || "N/A"} `,

        username: data?.user_name,
        password: data?.password,
        app_pass: data?.app_pass,
        app_name: data?.app_name,
        backup: data?.backup,
        template_guides: data?.template_guides,
        image_link: data?.image_link,
        username_image: data?.username_image,
        flag_show: data?.flag_show
    };
    const status = Number(accountInfo.status);
    const statuspower = data?.power;

    const packageInfo = {
        totalAmount: data?.package?.annual || "N/A",
        paymentCycle: data?.periods,
        paymentMethod: "N/A",
        start_date: data?.start_date || "N/A",
        end_date: data?.end_date || "N/A",
        nextBillingDate: "N/A",
    };


    const handleCopy = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopied(field);
        setTimeout(() => setCopied(""), 2000);
    };

    const handleUpgrade = async () => {
        navi(`/cshp/server/change-package/${orderID}`);
    };

    console.log("statuspower", statuspower)
    // const handleWebconsole = async () => {
    //     try {
    //         const response = await fetch(`${baseURL}/api/v1/control/get-console-websocket`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Authorization": `Bearer ${token}`
    //             },
    //             body: JSON.stringify({
    //                 order_detail_id: data?.id,
    //             })
    //         });

    //         if (!response.ok) {
    //             throw new Error("Có lỗi xảy ra khi chay websocket.");
    //         }

    //         const result = await response.json();
    //         const websocketUrl = result?.ticket;

    //         if (websocketUrl) {
    //             console.log("WebSocket URL:", websocketUrl);
    //             const ws = new WebSocket(websocketUrl);

    //             ws.onopen = () => {
    //                 console.log("Connected to WebSocket:", websocketUrl);
    //                 ws.send("Hello from client!");
    //             };

    //             ws.onmessage = (event) => {
    //                 console.log("Message from server:", event.data);
    //             };

    //             ws.onclose = () => {
    //                 console.log("WebSocket connection closed");
    //             };

    //             ws.onerror = (error) => {
    //                 console.error("WebSocket error:", error);
    //             };
    //         } else {
    //             console.error("Không có URL WebSocket trong kết quả.");
    //         }

    //     } catch (error) {
    //         console.error("Lỗi:", error);
    //     }
    // };

    // console.log("Status Power:", statuspower);

    const handleReinstallOS = async () => {
        let selectedImage = null;

        const filteredImages = images.filter(image =>
            image.min_core <= data.package.core &&
            image.min_memory <= data.package.memory &&
            image.min_storage <= data.package.storage
        );

        const imageOptions = filteredImages.map(image => `
            <option value="${image.id}">${image.name} (${image.version})</option>
        `).join('');

        const result = await Swal.fire({
            html: `
            <div class='row' style="font-size:14px; line-height:1.6;">
                <div class='col-12' style="margin-bottom:12px;">
                    <span style="font-size:16px;">
                        Bạn có chắc chắn muốn cài đặt lại máy ảo 
                        <strong>[ ${accountInfo?.domain_hosting_name || 'Tên Miền Chưa Cập Nhật'} ]</strong> 
                        không?
                    </span><br>
                    <span style="font-size:14px; line-height:1.6; color:red;">
                        Tất cả dữ liệu hiện tại trên máy ảo sẽ bị mất và không thể khôi phục.
                        Vui lòng sao lưu dữ liệu trước khi thực hiện
                    </span>
                </div>
                <div class='col-12' style="margin-bottom:12px;">
                    <b>Chọn image hệ điều hành:</b>
                </div>
                <div class='col-12' style="margin-bottom:12px;">
                    <select id="imageDropdown" style="padding: 8px; font-size: 14px; width: 250px; height: 40px; border: 1px solid #000; border-radius: 5px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                        ${imageOptions}
                    </select>
                </div>
                <div class='col-12' style="margin-bottom:12px;">
                    <b>Nhập chữ <span style="color:red;">CONFIRM</span> để xác nhận thao tác này:</b>
                </div>
                <div class='col-12'>
                    <input
                        id="confirmInput"
                        type="text"
                        autocomplete="off"

                        placeholder="Nhập CONFIRM để xác nhận"
                        style="padding: 8px; font-size: 14px; width: 250px; height: 30px; border: 1px solid #000; border-radius: 5px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                </div>
            </div>
            `,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            focusConfirm: false,
            showCloseButton: true,
            cancelButtonColor: "#dc3545",
            confirmButtonColor: "#007bff",
            customClass: {
                popup: 'swal2-popup-centered custom-popup',
                input: 'swal2-input-small',
                confirmButton: 'custom-confirm-button'

            },
            width: '600px',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {

                const imageDropdown = document.getElementById('imageDropdown');
                selectedImage = imageDropdown ? imageDropdown.value : null;
                const inputField = document.getElementById('confirmInput');
                const inputValue = inputField ? inputField.value : "";
                if (!selectedImage || inputValue.toUpperCase() !== "CONFIRM") {
                    Swal.showValidationMessage(`
                        <span style="color: red; font-size: 14px;">
                            ❌ Vui lòng chọn Image và nhập đúng CONFIRM!
                        </span>
                    `);
                    return false;
                } document.querySelector('.swal2-confirm').style.visibility = 'hidden';
                document.querySelector('.swal2-cancel').style.visibility = 'hidden';

                Swal.showLoading();


                try {
                    const response = await fetch(`${baseURL}/api/v1/control/reinstall`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            order_detail_id: data?.id,
                            id_image: selectedImage,
                            type: 1,
                            ip_address: ipAddress,
                        })
                    });

                    if (!response.ok) {
                        throw new Error("Có lỗi xảy ra khi cài đặt lại máy ảo.");
                    }

                    Swal.showValidationMessage(`
                        <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                            </svg>
                            <span>Thành công! Máy ảo đã được cài đặt lại.</span>
                        </div>
                    `);
                    Swal.hideLoading();
                    setTimeout(() => {
                        const cancelButton = document.querySelector('.swal2-cancel');
                        cancelButton.innerText = 'Close';
                        cancelButton.style.visibility = 'visible';
                        cancelButton.style.position = 'absolute';
                        cancelButton.style.left = '50%';
                        cancelButton.style.transform = 'translateX(-50%)';
                    });
                    setTimeout(() => {
                        Swal.close();
                    }, 2000);
                    delayFetchData(2000);
                    delayFetchData(2000);


                } catch (error) {
                    Swal.showValidationMessage(`
                        <span style="color: red; font-size: 14px;">
                            ❌ Lỗi: ${error.message}
                        </span>
                    `);
                    Swal.hideLoading();
                }
            }
        });

        if (!result.isConfirmed) {
            console.log("Hủy thao tác cài đặt lại.");
        }
    };

    const handleReset = async () => {
        const result = await Swal.fire({
            title: "Bạn có chắc chắn?",
            text: `Bạn có chắc chắn muốn khởi động lại máy ảo 
            [ ${accountInfo?.domain_hosting_name || 'Tên Miền Chưa Cập Nhật'} ] không?`,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            showCloseButton: true,
            cancelButtonColor: "#dc3545",
            confirmButtonColor: "#007bff",
            customClass: {
                popup: 'swal2-popup-centered custom-popup',
                confirmButton: 'custom-confirm-button'

            },
            width: '600px',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
                const confirmButton = document.querySelector('.swal2-confirm');
                const cancelButton = document.querySelector('.swal2-cancel');
                confirmButton.innerHTML = `<span class="loading-spinner"></span>`;
                confirmButton.classList.add("swal2-loading");
                confirmButton.disabled = true;


                try {
                    const response = await fetch(`${baseURL}/api/v1/control/reset`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            order_detail_id: data?.id,
                            ip_address: ipAddress,
                            type: 1

                        })
                    });

                    if (!response.ok) {
                        confirmButton.style.display = "none";
                        throw new Error("Có lỗi xảy ra khi khởi động lại máy ảo.");
                    }

                    Swal.showValidationMessage(`
                        <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                            </svg>
                            <span>Thành công! Máy ảo đã được khởi động lại.</span>
                        </div>
                    `);
                    Swal.hideLoading();
                    confirmButton.innerHTML = "Confirm";
                    confirmButton.classList.remove("swal2-loading");
                    confirmButton.disabled = true;
                    confirmButton.style.display = "none";

                    cancelButton.innerText = 'Close';
                    cancelButton.style.visibility = 'visible';
                    cancelButton.style.position = 'relative';
                    cancelButton.style.transform = 'none';


                    setTimeout(() => {
                        Swal.close();
                    }, 2000);

                    delayFetchData(2000);


                } catch (error) {
                    Swal.showValidationMessage(`
                        <span style="color: red; font-size: 14px;">
                            ❌ Lỗi: ${error.message}
                        </span>
                    `);

                    Swal.hideLoading();
                }
            }
        });

        if (!result.isConfirmed) {
            Swal.close();
        }
    };
    const handleStart = async () => {
        const result = await Swal.fire({
            title: "Bạn có chắc chắn?",
            text: `Bạn có chắc chắn muốn bật lại máy ảo 
            [ ${accountInfo?.domain_hosting_name || 'Tên Miền Chưa Cập Nhật'} ] không?`,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonColor: "#dc3545",
            confirmButtonColor: "#007bff",
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
                popup: 'swal2-popup-centered custom-popup',
                confirmButton: 'custom-confirm-button'
            },
            width: '600px',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
                const confirmButton = document.querySelector('.swal2-confirm');
                const cancelButton = document.querySelector('.swal2-cancel');

                // Hiển thị spinner và disable nút confirm
                confirmButton.innerHTML = `<span class="loading-spinner"></span>`;
                confirmButton.classList.add("swal2-loading");
                confirmButton.disabled = true;

                try {
                    const response = await fetch(`${baseURL}/api/v1/control/start`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            order_detail_id: data?.id,
                            ip_address: ipAddress,
                            type: 1
                        })
                    });

                    if (!response.ok) {
                        confirmButton.style.display = "none";
                        throw new Error("Có lỗi xảy ra khi bật lại máy ảo.");

                    }
                    Swal.showValidationMessage(`
                        <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                            </svg>
                            <span>Thành công! Máy ảo đã được bật lại.</span>
                        </div>
                    `);
                    Swal.hideLoading();
                    confirmButton.innerHTML = "Confirm";
                    confirmButton.classList.remove("swal2-loading");
                    confirmButton.disabled = true;
                    confirmButton.style.display = "none";

                    cancelButton.innerText = 'Close';
                    cancelButton.style.visibility = 'visible';
                    cancelButton.style.position = 'relative';
                    cancelButton.style.transform = 'none';


                    setTimeout(() => {
                        Swal.close();
                    }, 2000);

                    delayFetchData(2000);


                } catch (error) {
                    Swal.showValidationMessage(`
                       <span style="color: red; font-size: 14px;">
                           ❌ Lỗi: ${error.message}
                       </span>
                   `);
                    Swal.hideLoading();

                    // ✅ Reset lại Confirm button nếu lỗi
                    confirmButton.innerHTML = "Confirm";
                    confirmButton.classList.remove("swal2-loading");
                    confirmButton.disabled = false;
                }
            }
        });

        if (!result.isConfirmed) {
            Swal.close();
        }
    };




    const handleStop = async () => {
        const result = await Swal.fire({
            title: "Bạn có chắc chắn?",
            text: `Bạn có chắc chắn muốn tắt máy ảo 
            [ ${accountInfo?.domain_hosting_name || 'Tên Miền Chưa Cập Nhật'} ] không?`,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonColor: "#dc3545",
            confirmButtonColor: "#007bff",
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
                popup: 'swal2-popup-centered custom-popup',
                confirmButton: 'custom-confirm-button'

            },
            width: '600px',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
                const confirmButton = document.querySelector('.swal2-confirm');
                const cancelButton = document.querySelector('.swal2-cancel');

                confirmButton.innerHTML = `<span class="loading-spinner"></span>`;
                confirmButton.classList.add("swal2-loading");
                confirmButton.disabled = true;

                try {
                    const response = await fetch(`${baseURL}/api/v1/control/stop`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({

                            order_detail_id: data?.id,
                            ip_address: ipAddress,
                            type: 1
                        })
                    });

                    if (!response.ok) {
                        confirmButton.style.display = "none";
                        throw new Error("Có lỗi xảy ra khi tắt máy ảo.");
                    }

                    Swal.showValidationMessage(`
                        <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                            </svg>
                            <span>Thành công! Máy ảo đã được tắt.</span>
                        </div>
                    `);
                    Swal.hideLoading();
                    confirmButton.innerHTML = "Confirm";
                    confirmButton.classList.remove("swal2-loading");
                    confirmButton.disabled = true;
                    confirmButton.style.display = "none";

                    cancelButton.innerText = 'Close';
                    cancelButton.style.visibility = 'visible';
                    cancelButton.style.position = 'relative';
                    cancelButton.style.transform = 'none';


                    setTimeout(() => {
                        Swal.close();
                    }, 2000);

                    delayFetchData(2000);

                } catch (error) {
                    Swal.showValidationMessage(`
                        <span style="color: red; font-size: 14px;">
                            ❌ Lỗi: ${error.message}
                        </span>
                    `);

                    Swal.hideLoading();
                    confirmButton.innerHTML = "Confirm";
                    confirmButton.classList.remove("swal2-loading");
                    confirmButton.disabled = false;
                }
            }
        });

        if (!result.isConfirmed) {
            Swal.close();
        }
    };

    const isButtonDisabled = (buttonType) => {
        const restrictedStatuses = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        if (restrictedStatuses.includes(status)) {
            return true;
        }

        if (statuspower === "POWERED_OFF") {
            return buttonType !== 'start';
        }

        if (statuspower === "POWERED_ON") {
            return buttonType === 'start';
        }

        return false;
    };


    return (
        <div className="px-5 py-5">
            <div className="card mb-3">
                <div style={{ textTransform: "uppercase" }} className="card-header">
                    <i className="bi bi-info-circle-fill"></i> {t("Account Information")}
                </div>
                <div className="card-body">

                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <p><strong>OS</strong>: {accountInfo.osStatus} {accountInfo?.osversion}</p>
                            </div>
                            <div className="mb-3">
                                <p><strong>CPU</strong>: {accountInfo.cpu}</p>
                            </div>
                            <div className="mb-3">
                                <p><strong>RAM</strong>: {accountInfo.ram}</p>
                            </div>
                            <div className="mb-4">
                                <p><strong>NVMe</strong>: {accountInfo.ssd}</p>
                            </div>
                            <div className="mb-3">
                                <p>
                                    <strong>{t("Status")}: </strong>
                                    <span style={{
                                        color: status === 0 ? "#808080" :
                                            status === 1 ? "#28A745" :
                                                status === 2 ? "#FFC107" :
                                                    status === 3 ? "#DC3545" :
                                                        status === 4 ? "#343A40" :
                                                            status === 5 ? "#17A2B8" :
                                                                status === 6 ? "#FD7E14" :
                                                                    status === 7 ? "#007BFF" :
                                                                        status === 8 ? "#6F42C1" :
                                                                            status === 9 ? "#bcdbf7" :
                                                                                status === 10 ? "#A71D2A" :
                                                                                    "orange"
                                    }}>
                                        {status === 0 ? t("Pending") :
                                            status === 1 ? t("Active") :
                                                status === 2 ? t("Suspended") :
                                                    status === 3 ? t("Cancelled") :
                                                        status === 4 ? t("Fraud") :
                                                            status === 5 ? t("Complete") :
                                                                status === 6 ? t("Processing") :
                                                                    status === 7 ? t("On Hold") :
                                                                        status === 8 ? t("Pending Cancellation") :
                                                                            status === 9 ? t("Reinstall") :
                                                                                status === 10 ? t("Terminated") : t("Pending")}
                                    </span>
                                </p>
                            </div>

                        </div>

                        <div className="col-md-4">
                            <div className="mb-3">
                                <span><strong>{t("Hostname")}</strong>: {accountInfo.hostname}</span>
                                <span style={{ marginLeft: "175px" }}>

                                </span>


                            </div>
                            <div className="mb-3">
                                <p style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                                    <span style={{ display: "flex", alignItems: "center" }}>
                                        <strong>{t("IP address")}</strong>: {accountInfo.ipAddress}
                                        <a
                                            className="ms-2"
                                            style={{
                                                cursor: "pointer",
                                                color: "#007bff",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                marginLeft: "10px",
                                            }}
                                            onClick={() => handleCopy(accountInfo.ipAddress, "ipAddress")}
                                        >
                                            <BsClipboard size={13} style={{ marginLeft: "5px" }} />
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    color: "green",
                                                    marginLeft: "5px",
                                                    visibility: copied === "ipAddress" ? "visible" : "hidden",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {t("Copied")}!
                                            </span>
                                        </a>
                                    </span>

                                </p>
                            </div>

                            <div className="mb-3">
                                <strong>{t("Backup")}</strong>:
                                <span style={{ color: accountInfo.backup == "1" ? "#28A745" : "#DC3545", marginLeft: "5px" }}>
                                    {accountInfo.backup == "1" ? t("Yes") : t("No")}
                                </span>
                            </div>

                            <div className="mb-3">
                                <strong>{t("Port")}</strong>: {accountInfo.port}
                            </div>

                            <div style={{}} className="mb-3">
                                <p>
                                    <strong>{t("Power status")}: </strong>
                                    <span style={{
                                        color: (status === 3 || status == 2 || status == 0 || status == 6)
                                            ? "gray"
                                            : (statuspower === "POWERED_ON" ? "#28A745" : "#DC3545")
                                    }}>
                                        {(status === 3 || status == 2 || status == 0 || status == 6)
                                            ? "none"
                                            : (statuspower === "POWERED_ON" ? "Power On" : "Power Off")}
                                    </span>
                                </p>
                            </div>

                        </div>
                        {/* 
                        <div className="col-md-2 text-start">
                            <div className="mb-3">
                                <strong>{t("Backup")}</strong>:
                                <span style={{ color: accountInfo.backup == "1" ? "#28A745" : "#DC3545", marginLeft: "5px" }}>
                                    {accountInfo.backup == "1" ? t("Yes") : t("No")}
                                </span>
                            </div>
                            <div className="mb-3">
                                <strong>{t("Port")}</strong>: {accountInfo.port}
                            </div>
                        </div> */}

                    </div>

                    <div className="mt-4">
                        <div className="row">
                            <div className="col-6">
                                <button onClick={handleStart} className="btn" style={{ backgroundColor: isButtonDisabled('start') ? '#6c757d' : '#28a745', color: 'white', opacity: isButtonDisabled('start') ? 0.5 : 1 }} disabled={isButtonDisabled('start')}>{t("Start")}</button>
                                <button onClick={handleStop}
                                    className="btn"
                                    style={{
                                        backgroundColor: isButtonDisabled('stop') ? '#6c757d' : '#dc3545',
                                        color: 'white',
                                        opacity: isButtonDisabled('stop') ? 0.5 : 1
                                    }}
                                    disabled={isButtonDisabled('stop')}>
                                    {t("Stop")}
                                </button>

                                <button onClick={handleReset} className="btn" style={{ backgroundColor: isButtonDisabled('restart') ? '#6c757d' : '#ffc107', color: 'white', marginRight: '10px', opacity: isButtonDisabled('restart') ? 0.5 : 1 }} disabled={isButtonDisabled('restart')}>{t("Restart")}</button>

                                <button onClick={handleReinstallOS}
                                    className="btn" style={{ backgroundColor: isButtonDisabled('reinstall') ? '#6c757d' : '#007bff', color: 'white', marginRight: '10px', opacity: isButtonDisabled('reinstall') ? 0.5 : 1 }} disabled={isButtonDisabled('reinstall')}>{t("Reinstall OS")}</button>

                                {/* <button className="btn btn-primary"
                                    onClick={handleWebconsole}
                                >
                                    Web console
                                </button> */}
                            </div>
                            {accountInfo?.status === 1 && (
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-3">
                                            <button
                                                style={{ backgroundColor: "#0069ff", color: "white" }}

                                                className={`btn ${accountInfo?.status === 6 ? "disabled-button" : ""}`}
                                                onClick={handleUpgrade}
                                                disabled={statuspower === "POWERED_OFF"}
                                            >
                                                Change Package
                                            </button>
                                        </div>


                                        <div style={{ margin: "0px", padding: "0px" }} className="col-3">

                                            <button
                                                style={{ backgroundColor: "#dc3545", color: "white" }}

                                                className={`btn `}
                                                onClick={handleDeleteVM}
                                            // disabled={statuspower === "POWERED_OFF"}
                                            >
                                                {t("Delete VM")}
                                            </button>
                                        </div>
                                        <div className="col-3">
                                        </div>
                                    </div>

                                </div>
                            )}



                        </div>
                    </div>
                </div>
            </div>

            <div className="card" >
                <div className="row my-2 mx-2">
                    <div className='col-6'>
                        <i className="bi bi-list-check"></i> {t("User Guide")}
                    </div>
                    <div className='col-6'>
                        <i className="bi bi-list-check"></i> {accountInfo?.app_name} INFORMATION
                    </div>
                    <div className="col-md-6" style={{}}>
                        {accountInfo?.template_guides.map((row, index) =>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item border-0 py-2">
                                    <a
                                        href={row?.link_guide}
                                        className="text-decoration-none text-primary fw-semibold"
                                        target="_blank"

                                        style={{ color: "#007BFF" }}
                                        rel="noopener noreferrer"
                                    >
                                        {index + 1}. {row?.link_text}
                                    </a>
                                </li>

                            </ul>

                        )

                        }
                    </div>

                    <div className="col-md-6">

                        {accountInfo?.status === 1 && (
                            <div className="border-0 " >

                                <div style={{ width: "100%" }}>


                                    <div className="mb-3">
                                        <p>
                                            <strong>{t("Login link")} WH-Panel</strong>:
                                            <a
                                                href={process.env.REACT_APP_PANEL_URL}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#007bff",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    textDecoration: "none",
                                                    marginLeft: "5px"
                                                }}
                                            >
                                                {process.env.REACT_APP_PANEL_URL}
                                            </a>
                                            <a
                                                className="ms-2"
                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "none" }}
                                                onClick={() => handleCopy(process.env.REACT_APP_PANEL_URL, "image_link")}
                                            >
                                                <BsClipboard size={13} style={{ marginRight: "5px" }} />
                                                {copied === "image_link" && (
                                                    <span style={{ fontSize: "12px", color: "green", marginLeft: "5px", cursor: "pointer" }}>
                                                        {t("Copied")}!
                                                    </span>
                                                )}
                                            </a>
                                        </p>
                                    </div>




                                </div>
                            </div>
                        )}



                    </div>
                </div>
            </div>
        </div >
    );
};

export default OrderDetailPanel;